// Single source of truth for the Astra brand icon, used by both the launcher
// (CopilotTrigger) and the panel header (CopilotPanel). To rebrand both places,
// replace src/assets/astra-icon.svg (or repoint this import) — nothing else changes.
import astraIconUrl from 'src/assets/astra-icon.svg';

export const ASTRA_ICON_URL: string = astraIconUrl;
export const ASTRA_ICON_ALT = 'Astra';
